<template>
   <div class="sa-main">
      <div class="nuxt-loading-indicator" style="position:fixed;top:0;right:0;left:0;pointer-events:none;width:0%;height:5px;opacity:0;background:repeating-linear-gradient(to right,#00dc82 0%,#34cdfe 50%,#0047e1 100%);background-size:Infinity% auto;transition:width 0.1s, height 0.4s, opacity 0.4s;z-index:999999;"></div>
      <div data-v-8c5ca72d>
         <div class="el-row main-contact panel-block" style="" data-v-8c5ca72d>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-8c5ca72d></div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-sm-20 el-col-md-18 el-col-lg-18 el-col-xl-18" style="" data-v-8c5ca72d>
               <div class="contact" data-v-8c5ca72d>
                  <img class="title-bg" src="@/assets/image/fxzx/commission-bg.png" data-v-8c5ca72d>
                  <div class="title" data-v-8c5ca72d>用户端 </div>
               </div>
            </div>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-8c5ca72d></div>
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-8c5ca72d></div>
            <div class="el-col el-col-24 el-col-xs-24 el-col-sm-20 el-col-md-18 el-col-lg-18 el-col-xl-18" style="" data-v-8c5ca72d>
               <div class="contact-content" data-v-8c5ca72d>
				   <div class="imgbox">
				   		<img src="../assets/image/yonghuduan.png" alt="">
				   </div>
			   </div>
			   
			   
			   <!-- <div class="contact-content" data-v-8c5ca72d>
                     
                  <div data-v-8c5ca72d v-for="(item,index) in comList" :key="index" >
                     <div class="content-box" :class="[index%2!==0 && 'reverse-box']" data-v-8c5ca72d>
                        <div class="content-box-left" data-v-8c5ca72d>
                           <div class="left-bg" data-v-8c5ca72d>{{item.title}}</div>
                           <div class="left-title" data-v-8c5ca72d>{{item.desc}}</div>
                           <div data-v-8c5ca72d v-for="(ele,value) in item.items" :key="value" >
                              <div data-v-8c5ca72d>
                                 <div class="left-des" data-v-8c5ca72d>{{ele.title}}</div>
                                 <div data-v-8c5ca72d>
                                    <div class="left-des-title" data-v-8c5ca72d
                                    v-for="(text,val) in ele.descs" :key="val" >{{text.title}}</div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        <img class="content-box-right" :src="item.image" data-v-8c5ca72d>
                     </div>
                  </div>
               </div> -->
            </div>
			
			
            <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-8c5ca72d></div>
         </div>
		 <div class="el-row main-contact panel-block" style="" data-v-8c5ca72d>
		    <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-8c5ca72d></div>
		    <div class="el-col el-col-24 el-col-xs-24 el-col-sm-20 el-col-md-18 el-col-lg-18 el-col-xl-18" style="" data-v-8c5ca72d>
		       <div class="contact" data-v-8c5ca72d style="margin: 0;">
		          <!-- <img class="title-bg" src="@/assets/image/fxzx/commission-bg.png" data-v-8c5ca72d> -->
		          <div class="title" data-v-8c5ca72d>管理端 </div>
		       </div>
		    </div>
		    <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-8c5ca72d></div>
		    <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-8c5ca72d></div>
		    <div class="el-col el-col-24 el-col-xs-24 el-col-sm-20 el-col-md-18 el-col-lg-18 el-col-xl-18" style="" data-v-8c5ca72d>
		       <div class="contact-content" data-v-8c5ca72d>
		 				   <div class="imgbox">
		 				   		<img src="../assets/image/houduan.png" alt="">
		 				   </div>
		 			   </div>
		 			   
		 			   
		 			   <!-- <div class="contact-content" data-v-8c5ca72d>
		             
		          <div data-v-8c5ca72d v-for="(item,index) in comList" :key="index" >
		             <div class="content-box" :class="[index%2!==0 && 'reverse-box']" data-v-8c5ca72d>
		                <div class="content-box-left" data-v-8c5ca72d>
		                   <div class="left-bg" data-v-8c5ca72d>{{item.title}}</div>
		                   <div class="left-title" data-v-8c5ca72d>{{item.desc}}</div>
		                   <div data-v-8c5ca72d v-for="(ele,value) in item.items" :key="value" >
		                      <div data-v-8c5ca72d>
		                         <div class="left-des" data-v-8c5ca72d>{{ele.title}}</div>
		                         <div data-v-8c5ca72d>
		                            <div class="left-des-title" data-v-8c5ca72d
		                            v-for="(text,val) in ele.descs" :key="val" >{{text.title}}</div>
		                         </div>
		                      </div>
		                   </div>
		                </div>
		                <img class="content-box-right" :src="item.image" data-v-8c5ca72d>
		             </div>
		          </div>
		       </div> -->
		    </div>
		 			
		 			
		    <div class="el-col el-col-24 el-col-xs-0 el-col-sm-2 el-col-md-3 el-col-lg-3 el-col-xl-3" style="" data-v-8c5ca72d></div>
		 </div>
		 
   </div>
   </div>
</template>
<script>
   export default {
      name: 'commission',
      data(){
         return{
            // comList:[
            //    {
            //       title: "一",
            //       desc: "信息统计",
            //       image:require('@/assets/image/fxzx/0.png'),
            //       items: [{
            //          title: "1.版本信息"
            //       },{
            //          title: "2.常用功能"
            //       },{
            //          title: "3.数据统计",
            //          descs: [{
            //             title: "系统每日数据总统计"
            //          },{
            //             title: "大神接单每日总统计"
            //          },{
            //             title: "新增会员等数据总统计"
            //          }]
            //       }, {
            //          title: "4.服务支持",
            //          descs: [{
            //             title: "快速联系在线客服"
            //          }, {
            //             title: "系统自动更新"
            //          }, {
            //             title: "开发社区支持"
            //          }]
            //       }]
            //    }, {
            //       title: "二",
            //       desc: "分销商品管理",
            //       image:require('@/assets/image/fxzx/1.png'),
            //       items: [{
            //          title: "1.快速参与分销",
            //          desc: "分销商品可继承全局分销设置"
            //       }, {
            //          title: "2.批量设置",
            //          desc: "商品可批量设置分销佣金"
            //       }, {
            //          title: "3.针对单个商品独立设置",
            //          desc: "可具体到规格分配佣金百分比或金额， 重新设置分销层级、结算条件， 满足全品类商家的灵活佣金制度。"
            //       }]
            //    }, {
            //       title: "三",
            //       desc: "分销等级设置",
            //       image:require('@/assets/image/fxzx/2.png'),
            //       items: [{
            //          title: "1.配置最多10级的分销商等级",
            //          desc: "️满足商家市场推广的各种需求；如普通代理商，区县、市、省级制度或其它代理商制度。"
            //       }, {
            //          title: "2.自定义升级条件",
            //          desc: "含市面通用的升级制度，可根据团队、金额、单量信息结合一级、二级、团队架构灵活配置升级制度"
            //       }, {
            //          title: "3.预置多种成为分销商的条件",
            //          descs: [{
            //             title: "①自助申请，完善自定义表单即可成为分销商；"
            //          }, {
            //             title: "②购买任意一款分销商品即可成为分销商；"
            //          }, {
            //             title: "③商城消费累计满足金额后自动成为分销商。"
            //          }]
            //       }, {
            //          title: "4.结算配置",
            //          descs: [{
            //             title: "①可选择以具体商品价或实际支付价进行佣金比例的结算；"
            //          }, {
            //             title: "②设置佣金的结算到账方式(可根据商家运营模式选择调整)；"
            //          }, {
            //             title: "③退款后可选择是否扣除佣金、扣除上级分销商业绩。"
            //          }]
            //       }]
            //    }, {
            //       title: "四",
            //       desc: "分销商管理",
            //       image:require('@/assets/image/fxzx/3.png'),
            //       items: [{
            //          title: "1.审核分销商、审核分销商升级"
            //       }, {
            //          title: "2.更换上级推荐人、更换分销商等级"
            //       }, {
            //          title: "3.允许分销商升级开关"
            //       }, {
            //          title: "4.精确的团队信息统计、业绩统计"
            //       }, {
            //          title: "5.追踪分销商的分销动态、佣金流水和相关的分销订单"
            //       }]
            //    }, {
            //       title: "五",
            //       desc: "分销订单与佣金明细",
            //       image:require('@/assets/image/fxzx/4.png'),
            //       items: [{
            //          title: "1.可灵活筛选分销订单",
            //          desc: "根据下单用户、推广分销商、被分佣分销商灵活筛选"
            //       }, {
            //          title: "2.对结算数据精确计算",
            //          descs: [{
            //             title: "️①统计数据精确计算分销订单数量和结算金额、结算层级；"
            //          }, {
            //             title: "②结算时分销商等级和佣金剥比，方便商家随时掌握异常订单。"
            //          }]
            //       }, {
            //          title: "3.可修改未结算分销订单的佣金金额"
            //       }, {
            //          title: "4.可提前针对某订单或某分销商提前结算佣金和扣除佣金操作"
            //       }]
            //    }
            // ]
         }
      },
      methods:{
        
      },
      components: {
        
      },
      mounted() {
         window.scrollTo({top: 0, behavior:'smooth'});
      },
   };
</script>
<style scoped lang="sass">
   @import '../assets/css/commission.css'
</style>